import { iPadDown } from './mediaQueries';

export const borderRadius = `
    border-radius: .63vw;
    ${iPadDown} {
        border-radius: 1.93vw;
    }
`;

export const borderWidth = `
    border-width: .16vw;
    ${iPadDown} {
        border-width: .54vw;
    }
`;

// fonts
export const fontFamily = 'Whyte Trial, Arial, Helvetica, sans-serif'

export const titleFontSize = `
    font-size: 1.9vw;
    ${iPadDown} {
        font-size: 5.85vw;
    }
`;

export const desktopFontSize = '1.1vw';

export const mobileFontSize = '4.27vw';

export const fontSize = `
    font-size: ${desktopFontSize};
    ${iPadDown} {
        font-size: ${mobileFontSize};
    }
`;


export const errorColor = '#E90E00';
